/** Expense and revenue categories. Created for a new workspace by a PocketBase hook. */
import type { CategoriesResponse } from "@/lib/platform/pb-types";
import { pb } from "@/lib/platform/pocketbase";

export type Category = CategoriesResponse;

export type CategoryInput = {
  name: string;
  kind: Category["kind"];
  accountNumber: string;
  vatRate: number;
  deductiblePercent: number;
};

export async function listCategories(workspaceId: string): Promise<Category[]> {
  return pb.collection("categories").getFullList<Category>({
    filter: pb.filter("workspace = {:workspaceId} && archived != true", { workspaceId }),
    sort: "kind,sortOrder,accountNumber",
  });
}

export async function createCategory(workspaceId: string, input: CategoryInput): Promise<Category> {
  return pb.collection("categories").create({ ...input, workspace: workspaceId, sortOrder: 999 });
}

export async function updateCategory(id: string, input: Partial<CategoryInput>): Promise<Category> {
  return pb.collection("categories").update(id, input);
}

/** Categories are archived rather than deleted so historic documents keep their account. */
export async function archiveCategory(id: string): Promise<Category> {
  return pb.collection("categories").update(id, { archived: true });
}
